import { List, Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import Placeholder from "components/Placeholder";
import ConfigSectorsAreaContainer from "./ConfigSectorsAreaContainer";

const ConfigSectorsContainerLayout = styled(Paper)``;

function ConfigSectorsContainer({ areasLoading, areas, initialized }) {
  if (areasLoading || !initialized) {
    return (
      <ConfigSectorsContainerLayout>
        <Placeholder />
      </ConfigSectorsContainerLayout>
    );
  }

  return (
    <ConfigSectorsContainerLayout>
      <List>
        {areas?.map((area, index) => (
          <ConfigSectorsAreaContainer area={area} key={index} />
        ))}
      </List>
    </ConfigSectorsContainerLayout>
  );
}

const mapStateToProps = (state) => ({
  areasLoading: state.ConfigSectors.areas.loading,
  areas: state.ConfigSectors.areas.items,
  initialized: state.ConfigSectors.initialized,
});

export default connect(mapStateToProps)(ConfigSectorsContainer);
